import React, { useEffect } from 'react';
// Pages
import Signin from './components/Signin';
import Signup from './components/Signup';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import Profile from './pages/Profile';
import UserProfile from './pages/userProfile';
import AddNewProject from './pages/AddNewProject';
import ProjectDetail from './pages/ProjectDetail';
import MyProjects from './pages/MyProjects';
import AppliedProjects from './pages/AppliedProjects';
import Layout from './Layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';

import { Link, Route, Routes } from 'react-router-dom';
import { AuthContextProvider } from './context/AuthContext';

function App() {
  return (
    <div>
      <AuthContextProvider>
        <Routes>
          <Route path='/signin' element={<Signin />} />
          <Route path='/signup' element={<Signup />} />
          <Route path='/' element={<Dashboard />} />
          <Route
            path='/'
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path='/projects' element={<Projects />} />
            <Route path='/add-new-project' element={<AddNewProject />} />
            <Route path='/projects/:id' element={<ProjectDetail />} />
            <Route path='/my-projects' element={<MyProjects />} />
            <Route path='/profile' element={<Profile />} />
            <Route path='/profile/:id' element={<UserProfile />} />
            <Route path='/applied-projects' element={<AppliedProjects />} />
            <Route path='*' element={<h1>404 Not Found<Link to='/'>Go Home</Link></h1>} />
          </Route>
        </Routes>
      </AuthContextProvider>
    </div>
  );
}

export default App;
